import { render, staticRenderFns } from "./UpdateSubdomainDialog.vue?vue&type=template&id=3e634bcf&scoped=true"
import script from "./UpdateSubdomainDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateSubdomainDialog.vue?vue&type=script&lang=ts"
import style0 from "./UpdateSubdomainDialog.vue?vue&type=style&index=0&id=3e634bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e634bcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextField})
